import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet (404) | Kita Akupunktur</title>
        <meta
          name="description"
          content="Siden du leder efter findes desværre ikke hos Kita Akupunktur. Gå til forsiden for at læse om vores akupunkturbehandlinger i Risskov."
        />
        <meta property="og:title" content="Siden blev ikke fundet (404) | Kita Akupunktur" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-[60vh] flex items-center justify-center py-20 px-4">
        <div className="max-w-lg w-full text-center glass-card p-8 sm:p-12 rounded-3xl border border-[#ffe0cf] shadow-md">
          <div className="w-16 h-16 rounded-full bg-[#ffe0cf] text-[#d74814] flex items-center justify-center mx-auto mb-4 text-2xl font-serif font-bold">
            404
          </div>
          <h1 className="text-2xl sm:text-3xl font-serif text-[#593427] font-bold mb-3">
            Siden blev ikke fundet
          </h1>
          <p className="text-[#593427]/80 text-sm sm:text-base mb-6 leading-relaxed">
            Det ser ud til, at der ikke kunne findes noget her. Prøv at gå til forsiden eller kontakt klinikken.
          </p>

          <div className="space-y-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center w-full px-6 py-3 rounded-full bg-[#d74814] text-white font-semibold text-sm hover:bg-[#593427] transition-colors"
            >
              <i className="fa-solid fa-house mr-2 text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center w-full px-6 py-3 rounded-full border border-[#ffe0cf] bg-white text-[#593427] font-semibold text-sm hover:bg-[#ffe0cf]/50 transition-colors"
            >
              <span>Kontakt klinikken</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}